// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let ProfilePhotoInput = require("../common/ProfilePicture/ProfilePhotoInput.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MarketingProfileMemberPhotoFormMutation_graphql = require("../../__generated__/MarketingProfileMemberPhotoFormMutation_graphql.bs.js");
let AvatarDefaultSvg = require("../../../assets/images/elements/avatar-default.svg");
let MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql = require("../../__generated__/MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.bs.js");
let MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql = require("../../__generated__/MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.bs.js");
let MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql = require("../../__generated__/MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.bs.js");

let convertFragment = MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let avatarPlaceholder = AvatarDefaultSvg;

function MarketingProfileMemberPhotoForm$CurrentPhoto(props) {
  let member = RescriptRelay_Fragment.useFragment(MarketingProfileMemberPhotoForm_currentPhoto_marketingProfileMember_graphql.node, convertFragment, props.member);
  let profilePicture = member.profilePicture;
  let src = profilePicture !== undefined ? profilePicture.url : avatarPlaceholder;
  let match = member.profilePicture;
  let alt = match !== undefined ? "Your current profile picture" : "Placeholder profile picture showing a person's silhouette";
  return JsxRuntime.jsx("img", {
    className: "w-24 h-24 rounded-full",
    alt: alt,
    src: src
  });
}

let CurrentPhoto = {
  Fragment: Fragment,
  avatarPlaceholder: avatarPlaceholder,
  make: MarketingProfileMemberPhotoForm$CurrentPhoto
};

let convertFragment$1 = MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertVariables = MarketingProfileMemberPhotoFormMutation_graphql.Internal.convertVariables;

let convertResponse = MarketingProfileMemberPhotoFormMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = MarketingProfileMemberPhotoFormMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MarketingProfileMemberPhotoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables, MarketingProfileMemberPhotoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

let Mutation_imageContentType_decode = MarketingProfileMemberPhotoFormMutation_graphql.Utils.imageContentType_decode;

let Mutation_imageContentType_fromString = MarketingProfileMemberPhotoFormMutation_graphql.Utils.imageContentType_fromString;

let Mutation = {
  imageContentType_decode: Mutation_imageContentType_decode,
  imageContentType_fromString: Mutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

function MarketingProfileMemberPhotoForm$ChangeProfilePhoto(props) {
  let onNewPhotoSaved = props.onNewPhotoSaved;
  let member = RescriptRelay_Fragment.useFragment(MarketingProfileMemberPhotoForm_changeProfilePhoto_marketingProfileMember_graphql.node, convertFragment$1, props.member);
  let match = use$2();
  let mutate = match[0];
  let match$1 = member.profilePicture;
  let buttonText = match$1 !== undefined ? "Change photo" : "Add photo";
  return JsxRuntime.jsx(ProfilePhotoInput.make, {
    onSubmit: (param, param$1) => {
      let notifyOnError = param$1.notifyOnError;
      let notifyOnSuccess = param$1.notifyOnSuccess;
      mutate({
        input: {
          memberId: member.id,
          profilePhoto: {
            croppedPhoto: param.croppedPhoto,
            originalPhoto: param.originalPhoto
          }
        }
      }, undefined, undefined, undefined, (_response, errors) => {
        if (errors !== undefined) {
          return notifyOnError("There was an error saving your photo. Please try again.");
        } else {
          notifyOnSuccess();
          return onNewPhotoSaved();
        }
      }, param => notifyOnError("There was an error saving your photo. Please try again."), undefined);
    },
    onPhotoSelected: props.onNewPhotoSelected,
    buttonText: buttonText
  });
}

let ChangeProfilePhoto = {
  Fragment: Fragment$1,
  Mutation: Mutation,
  make: MarketingProfileMemberPhotoForm$ChangeProfilePhoto
};

let convertFragment$2 = MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

let Fragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MarketingProfileMemberPhotoForm$WithoutErrorBundary(props) {
  let member = RescriptRelay_Fragment.useFragment(MarketingProfileMemberPhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, props.member);
  let match = React.useState(() => "InitialState");
  let setState = match[1];
  let tmp;
  tmp = match[0] === "InitialState" ? null : JsxRuntime.jsx(Alert.Success.make, {
      title: Stdlib_Option.getOr(member.firstName, member.displayName) + `'s photo was updated`
    });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(MarketingProfileMemberPhotoForm$CurrentPhoto, {
            member: member.fragmentRefs
          }),
          JsxRuntime.jsx(MarketingProfileMemberPhotoForm$ChangeProfilePhoto, {
            member: member.fragmentRefs,
            onNewPhotoSaved: () => setState(param => "Success"),
            onNewPhotoSelected: () => setState(param => "InitialState")
          })
        ],
        className: "mt-2 sm:mt-0 flex gap-6 items-center md:flex-col lg:flex-row"
      }),
      JsxRuntime.jsx("div", {
        children: tmp,
        className: "flex"
      })
    ],
    className: "sm:py-6 space-y-4"
  });
}

let WithoutErrorBundary = {
  make: MarketingProfileMemberPhotoForm$WithoutErrorBundary
};

function MarketingProfileMemberPhotoForm(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "Profile photo",
    children: JsxRuntime.jsx(MarketingProfileMemberPhotoForm$WithoutErrorBundary, {
      member: props.member
    })
  });
}

let make = MarketingProfileMemberPhotoForm;

exports.CurrentPhoto = CurrentPhoto;
exports.ChangeProfilePhoto = ChangeProfilePhoto;
exports.Fragment = Fragment$2;
exports.WithoutErrorBundary = WithoutErrorBundary;
exports.make = make;
/* avatarPlaceholder Not a pure module */
